var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeetballMenu = function SvgMeetballMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#MeetballMenu_svg__a)",
    fill: "#535353"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.286 13.571a1.286 1.286 0 1 0 0-2.57 1.286 1.286 0 0 0 0 2.57ZM12.286 20.571a1.286 1.286 0 1 0 0-2.57 1.286 1.286 0 0 0 0 2.57ZM12.286 6.571a1.286 1.286 0 1 0 0-2.571 1.286 1.286 0 0 0 0 2.571Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "MeetballMenu_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgMeetballMenu;